import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=529bc130&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"
import style0 from "./productType.vue?vue&type=style&index=0&id=529bc130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529bc130",
  null
  
)

export default component.exports